import { Optional } from '@angular/core'
import { ModalController } from '@ionic/angular'

export abstract class LazyModalService<T> {
  protected constructor(@Optional() protected modalCtrl: ModalController) {}

  abstract open(data: T): Promise<HTMLIonModalElement>
}
